import { EventType } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useContext, useEffect } from 'react';
import { CONFIG } from '../../config';
import { AccountContext } from '../../contexts/AccountContext';
import Button from 'react-bootstrap/esm/Button';

/**
 * Login button to start a connection with Azure Active Directory
 */
const LoginButton = (props: {onLoad: (value: boolean) => void}) => {
    const { instance } = useMsal();

    // Get Account context to read and save information
    const account = useContext(AccountContext);
    
    useEffect(() => {
        const callbackId = instance.addEventCallback((message: { eventType: EventType; payload: any; }) => {
            // This will be run every time an event is emitted after registering this callback
            if (message.eventType === EventType.LOGIN_SUCCESS || message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
                const result = message.payload;

                account.setRoles(result.account.idTokenClaims.roles) // If the roles are not saved correctly, the problem is the getter and setter functions

                var hasRole = false;
                result.account.idTokenClaims.roles.forEach((role: string) => {
                    if(role.includes("mw")) {
                        hasRole = true;
                        return null;
                    }
                });

                if(!hasRole) {
                    props.onLoad(false);
                    return instance.logout({
                        account: instance.getActiveAccount(),
                        onRedirectNavigate: (url) => {
                            window.location.href = "/error";
                            return false;
                        }
                    });
                }

                
                checkLogin(result.accessToken)
            }
        });             

        return () => {
            // This will be run on component unmount
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        }
        
    }, []);

    /**
     * Send to the WLD's API the access token of the Azure account to check if it is correct
     * @param accessToken Access token which is given by Azure
     */
    const checkLogin = (accessToken: string) => {
        props.onLoad(true);

        let formData = new FormData();
        formData.append('access_token', accessToken);

        fetch(CONFIG.apiURI+"/login", 
            { 
                method: 'POST',
                mode: "cors",
                headers: {
                    Accept: 'application/json',
                },
                body: formData
            }
        ).then((response) => response.json())
        .then((data) => {
            account.setToken(data["token"]);
            account.setAccountID(data["idAccount"]);
            account.setAdID(data["adId"]);
            account.setDisplayName(data["displayname"]);
            window.location.href = "/";
            props.onLoad(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    /**
     * Redirect into the Azure connection interface
     * @param loginType 
     */
    const handleLogin = (loginType: string) => {
        if (loginType === "redirect") {
            instance.loginRedirect({scopes: CONFIG.scopes}).catch(e => {
                console.log(e);
            });
        }
    }

    const requestAccess = () => {
        window.open('mailto:'+CONFIG.requestAccessEmail+'?subject=Request access to Wavence Link Designer');
    }

    return (
        <>
            <div className='login-vertical-button-list div-horizontal-center'>
                <Button className="action-button p-3" bsPrefix="" variant="" onClick={() => handleLogin("redirect")}>Sign in</Button>
                <Button className="secondary-action-button p-3" bsPrefix="" variant="" onClick={() => requestAccess()}>Request access</Button>
            </div>
        </>
    );
}

export default LoginButton;